import './utils/extendLocale';

export * from './components';

export const version = '@antv/s2-react-v2.2.0';
